import {executeRequest} from "../../../../../database/firebase/api";
import {
  BUDGET_SUMMARY_SECTION_TYPE,
  BudgetEntry,
  BudgetEntryProps,
} from "@natomas-org/core";
import { auth } from "../../../../../database/firebase";

export const fetchEditingBudgetTable = async (props: {
  projectId: string;
  section: BUDGET_SUMMARY_SECTION_TYPE | string;
}): Promise<null | BudgetEntry[]> => {
  return fetchGenericBudgetTable({
    ...props,
    editing: true,
  });
};
export const fetchVisualBudgetTable = async (props: {
  projectId: string;
  section: BUDGET_SUMMARY_SECTION_TYPE | string | null;
}): Promise<null | BudgetEntry[]> => {
  return fetchGenericBudgetTable({
    ...props,
    editing: false,
  });
};
const fetchGenericBudgetTable = async (props: {
  projectId: string;
  section: BUDGET_SUMMARY_SECTION_TYPE | string | null;
  editing: boolean;
}): Promise<null | BudgetEntry[]> => {
  // Auth validation before API call
  if (!auth.currentUser) {
    console.error("🔴 fetchGenericBudgetTable: No authenticated user");
    throw new Error("User not authenticated");
  }

  // Validate projectId
  if (!props.projectId) {
    console.error("🔴 fetchGenericBudgetTable: No project ID provided");
    throw new Error("Project ID is required");
  }

  // Debug current user and project context
  const currentUser = auth.currentUser;
  


  const endpoint = props.editing
    ? "/price/v1/admin-budget"
    : "/price/v1/budget";
    

  

    
  return executeRequest(endpoint, {
    ...props,
    includeTotal: true,
  })
    .then((response: {data: BudgetEntryProps[]}) => {

      return response?.data?.map((entry: BudgetEntryProps) => {
        return new BudgetEntry(entry);
      });
    })
    .catch((error) => {
      console.error(`🔴 Budget fetch failed for project ${props.projectId}:`, {
        error: error,
        userId: currentUser.uid,
        projectId: props.projectId,
        endpoint: endpoint,
        payload: {
          ...props,
          includeTotal: true,
        }
      });
      return null;
    });
};
